export default __webpack_public_path__ + "static/media/Silver.e8ef8b06.png";